import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Section from "../../common/Section";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import * as types from "../../../constants/ComponentConstants";
import LusForm from "./LusForm";
import LusPageHelper from "./LusPageHelper";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import EasterEggHandler from "../../common/EasterEggHandler";
import * as pageConstants from "../../../constants/EasterEggConstants";
import redirector from "../../../util/redirector";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";

const initialeState = {
	model: {
		tocht: {},
		validatiestatusses: [],
		straten: []
	},
	lusTypes: [],
	fileComponents: {},
	errors: null,
	hasUnsavedChanges: false,
	fileSessionId: null,
	gpxChanged: false,
	showGPXChangedPopup: false,
	gpxDropped: false,
	gpxDeleted: false,
	showAnbPopup: false,
	scrollToTop: false,
	shouldScrollToFirstError: false,
	showMap: false,
	routeModel: null,
	mapBounds: [],
	originalGpxContent: null,
	isMapLoading: false,
	isMapEditable: false,
	drawingRoute: false,
	routeEdited: false,
	werkelijkeAfstand: 0
};

class LusPage extends ScrollToFirstErrorComponent {

	constructor(props, context) {
		super(props, context, true);
		this.filesHelper = null;
		this.state = initialeState;
		this.pageHelper = new LusPageHelper(this, redirector);
		this.testFiller = new EasterEggHandler(this, pageConstants.WIJZIG_LUS);
	}

	componentDidMount = () => {
		const params = this.props.match.params;
		const modelId = params.modelId;

		if (this.props.shouldRedirect)
			redirector.goTo(`e-loket/organisator/${modelId}/false`);
		else {
			this.testFiller.bind();
			super.componentDidMount();
			this.pageHelper.init();
		}
	};

	componentWillUnmount() {
		this.testFiller.unbind();
		this.props.hideSideNav();

		this.state = {
			model: null
		};
	}

	componentDidUpdate = (prevProps) => {
		super.componentDidUpdate();

		if (this.hasLusIdChanged(prevProps)) {
			this.setState(initialeState, () => { this.pageHelper.init(); });
		}
		if (this.state.scrollToTop) {
			window.parent.scrollTo(0, 450);
			this.setState({
				scrollToTop: false
			});
		}
	};

	hasLusIdChanged(prevProps) {
		const paramLusId = this.props.match.params.lusId;

		return prevProps.match.params.lusId != paramLusId;
	}


	handleOnChange = (event) => this.pageHelper.change(event);
	handleOnSave = (mapRef, routeFitted) => this.pageHelper.save(mapRef, routeFitted);

	handleOnChangeBevoorradingstentenInANBGebied = (event) => this.pageHelper.changeBevoorradingstentenInANBGebied(event);

	handleOnDropGPXBestand = (component, files) => this.pageHelper.dropGPXBestand(files);
	handleOnDeleteGPXBestand = () => this.pageHelper.deleteGPXBestand();
	handleOnClickDownloadGPXBestand = () => this.pageHelper.downloadGPXBestand();
	handleOnGemeenteGewijzigd = (confirmed) => this.pageHelper.gemeenteGewijzigd(confirmed);
	handleOnConfirmAnbPopup = () => this.pageHelper.confirmAnbPopup();

	handleOnUploadFiles = (component, files) => this.filesHelper.uploadFiles(component, files);
	handleOnDeleteFile = (component, file) => this.filesHelper.deleteOneFile(component, file);

	handleRouteUpdated = (newGeoJson) => this.pageHelper.routeUpdated(newGeoJson);
	handleRouteCreated = (newGeoJson) => this.pageHelper.routeCreated(newGeoJson);
	handleOnReverseRoute = () => this.pageHelper.reverseRoute();

	handleResetGpx = () => this.pageHelper.resetGpx();

	handleEditRoute = (mapCallback) => this.pageHelper.editRoute(mapCallback);
	handleMarkersEditStart = () => this.pageHelper.markersEditStart();

	handleDrawingRoute = () => this.pageHelper.drawingRoute();

	isReadyToRender = () => {
		return !!this.filesHelper;
	};

	render() {
		if (!this.isReadyToRender())
			return null;

		const state = this.state;
		const model = state.model;
		const props = this.props;
		const disabled = props.disabled || state.isMapEditable || state.drawingRoute;
		const errors = state.errors;
		const color = types.COLOR_RED;
		const GPXBestandFileTypes = props.GPXBestandFileTypes;
		const showGPXChangedPopup = state.showGPXChangedPopup;
		const validationMessageType = state.validationMessageType;
		const showAnbPopup = state.showAnbPopup;
		const fileComponents = state.fileComponents;
		const downloadFileUrl = this.filesHelper.getFileDownloadUrl();
		const stratenlijstFilesProps = this.pageHelper.getStratenlijstFilesProps();
		stratenlijstFilesProps.color = color;
		const osmBaseLayerUrl = props.osmBaseLayerUrl;
		const bevoorradingMarkerName = props.bevoorradingMarkerName;
		const isMapLoading = state.isMapLoading;

		return (
			<Section title={`Gegevens per afstand : ${model.naam || ""}`} color={color}>
				<LusForm
					model={model}
					lusTypes={state.lusTypes}
					disabled={disabled}
					onChange={this.handleOnChange}
					onChangeBevoorradingstentenInANBGebied={this.handleOnChangeBevoorradingstentenInANBGebied}
					onSave={this.handleOnSave}
					errors={errors}
					color={color}
					GPXBestandFileTypes={GPXBestandFileTypes}
					onDropGPXBestand={this.handleOnDropGPXBestand}
					onDeleteGPXBestand={this.handleOnDeleteGPXBestand}
					onDrop={this.handleOnUploadFiles}
					onDelete={this.handleOnDeleteFile}
					fileComponents={fileComponents}
					downloadFileUrl={downloadFileUrl}
					onClickDownloadGPXBestand={this.handleOnClickDownloadGPXBestand}
					showGPXChangedPopup={showGPXChangedPopup}
					onGemeenteGewijzigd={this.handleOnGemeenteGewijzigd}
					validationMessageType={validationMessageType}
					showAnbPopup={showAnbPopup}
					onConfirmAnbPopup={this.handleOnConfirmAnbPopup}
					stratenlijstFilesProps={stratenlijstFilesProps}
					showStratenlijstCSV={!state.gpxDropped && !state.gpxDeleted && !state.routeEdited}
					showGemeentenLijst={!state.gpxDropped && !state.gpxDeleted && !state.routeEdited}
					osmBaseLayerUrl={osmBaseLayerUrl}
					bevoorradingMarkerName={bevoorradingMarkerName}
					routeModel={state.routeModel}
					mapBounds={state.mapBounds}
					handleRouteUpdated={this.handleRouteUpdated}
					handleRouteCreated={this.handleRouteCreated}
					onReverseRoute={this.handleOnReverseRoute}
					handleResetGpx={this.handleResetGpx}
					isMapLoading={isMapLoading}
					handleRouteEditable={this.handleEditRoute}
					handleMarkersEditStart={this.handleMarkersEditStart}
					handleDrawingRoute={this.handleDrawingRoute}
					werkelijkeAfstand={state.werkelijkeAfstand}
				/>
			</Section>
		);
	}
}

LusPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
	const shouldRedirect = !state.layout.topNavTabsSet;
	const svlDossierId = state.settings.svlDossierId;
	return {
		validatieStatussen: state.validatieStatussen,
		GPXBestandFileTypes: state.settings.fileTypes[types.FileComponentNames.GPX_BESTAND],
		disabled: state.settings.disabled,
		shouldRedirect: shouldRedirect,
		maxMapFeaturesToLoad: state.settings.maxMapFeaturesToLoad,
		osmBaseLayerUrl: state.settings.osmBaseLayerUrl,
		bevoorradingMarkerName: state.settings.bevoorradingMarkerName,
		bepijlingMarkerName: state.settings.bepijlingMarkerName,
		svlDossierId: svlDossierId
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadLusLayout, dispatch),
		enableTopNav: bindActionCreators(layoutActions.enableTopNav, dispatch),
		disableTopNav: bindActionCreators(layoutActions.disableTopNav, dispatch),
		showSideNav: bindActionCreators(layoutActions.showSideNav, dispatch),
		hideSideNav: bindActionCreators(layoutActions.hideSideNav, dispatch),
		validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
		ajaxActions: bindActionCreators(ajaxActions, dispatch),
		throwException: bindActionCreators(throwException, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(LusPage);
